var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal show modal__likers-list" }, [
    _c("section", [
      _c("a", { staticClass: "modal__close" }, [
        _c("i", {
          staticClass: "icon-close",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "likers-list-component" },
        [
          _c(
            "vuescroll",
            {
              attrs: { ops: _vm.scrollOpt },
              on: { "handle-scroll": _vm.handleScroll }
            },
            [
              _c(
                "div",
                { staticClass: "wrapper" },
                [
                  _vm._l(_vm.likers, function(liker) {
                    return _c("LikerItem", {
                      key: liker.id,
                      attrs: { liker: liker },
                      on: {
                        click: function($event) {
                          return _vm.$emit("close")
                        }
                      }
                    })
                  }),
                  _vm._v(" "),
                  _vm.loading
                    ? _c("div", { staticClass: "spinner-border" })
                    : _vm._e()
                ],
                2
              )
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }